import CreateCategory from '@plugin/categories/views/CreateCategory';
import CreateModule from '@plugin/modules/views/CreateModule';
import CreateUser from '@plugin/users/views/CreateUser';
import CreateContacts from '@plugin/contacts/views/CreateContacts';
import Notes from '@components/notes/Notes';
import Mail from '@plugin/mail/Mail';
import CustomLayoutBuilder from '@plugin/customFieldsBuilder/views/CustomLayoutBuilder';

// Stores
import { useCategoryCreateStore } from '@plugin/categories/store/useCategoryCreateStore';
import { useModuleCreateStore } from '@plugin/modules/store/useModuleCreateStore';
import { useUsersCreateStore } from '@plugin/users/store/useUsersCreateStore';
import { useEmailCreateStore } from '@plugin/mail/store/useMailStore';
import { useContactsCreateStore } from '@plugin/contacts/store/useContactsCreateStore';

import { useCustomLayoutsStore } from '@plugin/customFieldsBuilder/store/CustomLayoutBuilderStore';
import { useNotesStore } from '@components/notes/store/useNotesStore';
// Core modal/component catalog (key + Component + store)
export const coreModalsConfig = [
  { key: 'modules', Component: CreateModule, store: useModuleCreateStore },
  { key: 'users', Component: CreateUser, store: useUsersCreateStore },
  // If you open a separate "create lead" modal by another key, keep it distinct:
  { key: 'notes', Component: Notes, store: useNotesStore },
  { key: 'category', Component: CreateCategory, store: useCategoryCreateStore },
  { key: 'customLayout', Component: CustomLayoutBuilder, store: useCustomLayoutsStore },
  { key: 'mail', Component: Mail, store: useEmailCreateStore },
  { key: 'contact', Component: CreateContacts, store: useContactsCreateStore },
  
];

// Optional: export a core store map (handy for merging with custom)
export const coreStores = coreModalsConfig.reduce((acc, m) => {
  if (m.key && typeof m.store === 'function') acc[m.key] = m.store;
  return acc;
}, {});